
import { createPermission } from '@backstage/plugin-permission-common';

export const requestManagerCreatePermission = createPermission({
  name: 'request-manager.request.create',
  attributes: { action: 'create' },
});

export const requestManagerReadPermission = createPermission({
  name: 'request-manager.request.read',
  attributes: { action: 'read' },
});

export const requestManagerCancelPermission = createPermission({
  name: 'request-manager.request.cancel',
  attributes: { action: 'create' },
});

export const requestManagerStartPermission = createPermission({
  name: 'request-manager.request.start',
  attributes: { action: 'create' },
});

export const requestManagerFinishPermission = createPermission({
  name: 'request-manager.request.finish',
  attributes: { action: 'create' },
});

export const amqpTopologyPermissions = [
  requestManagerCreatePermission,
  requestManagerReadPermission,
  requestManagerStartPermission,
  requestManagerFinishPermission,
];
